import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// recharge, send_gift, receive_gift, active
export enum ACTIVITIESSTRING {
  recharge = 'recharge',
  send_gift = 'send_gift',
  receive_gift = 'receive_gift',
  active = 'active',
}

export enum Ramadam2024Tab {
  recharge = 0,
  send_gift = 1,
  receive_gift = 2,
  active = 3,
}

export enum Ramadam2024From {
  roomBanner = 1,
  pageBanner = 2,
  im = 3,
  openApp = 4,
  sheep = 5,
  main = 6,
  share = 8,
}

export const ActivitiesConfig = [
  {
    label: 'recharge',
    value: 0,
  },
  {
    label: 'send_gift',
    value: 1,
  },
  {
    label: 'receive_gift',
    value: 2,
  },
  {
    label: 'active',
    value: 3,
  },
]

// 活动状态
export enum ACTSTATUS {
  未开始 = 0,
  进行中 = 1,
  已结束 = 2,
}

// 2024斋月活动聚合页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127594489
export const getRamadanCenter = createAsyncThunk(
  '/live/activity/ramadan_activity_center',
  async (arg, store: any) => {
    const resp = await http.post(
      '/live/activity/ramadan_activity_center',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return {
      ...resp.data.data,
    }
  }
)

// 2024活跃打卡界面信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127594815
export const getActiveClock = createAsyncThunk(
  '/live/activity/get_active_clock_info',
  async (arg, store: any) => {
    const resp = await http.post('/live/activity/get_active_clock_info', {
      ...store.getState().env.deviceinfo,
    })

    return {
      ...resp.data.data,
    }
  }
)
// 2024斋月红包派送活动 获取红包等级配置、当前红包等级 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127595974
export const getRedPage = createAsyncThunk(
  '/live/activity/red_envelope_page',
  async (arg, store: any) => {
    const resp = await http.post('/live/activity/red_envelope_page', {
      ...store.getState().env.deviceinfo,
    })
    return {
      ...resp.data.data,
    }
  }
)
// 2024斋月红包派送活动 打开红包 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127595974
export const openRedEnvelope = createAsyncThunk(
  '/live/activity/open_red_envelope',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/activity/open_red_envelope', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return {
      ...resp.data.data,
    }
  }
)
// 奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=127576311
export const get_reward_by_tag = createAsyncThunk(
  '/live/commonactivity/get_reward_by_tag',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        map: any
      }>
    >('/live/commonactivity/get_reward_by_tag', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 2024斋月白天黑夜 http://wiki.xunlei.cn/pages/viewpage.action?pageId=108635239
export const rdn_pray_page = createAsyncThunk(
  '/live/activity/rdn_pray_page',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/activity/rdn_pray_page', {
      ...store.getState().env.deviceinfo,
    })
  
    return {
      ...resp.data.data,
    }
    // TODO: 需要修改
  //   return {
  //     "err_msg": "",
  //     "activity_expire": 3404658,
  //     "activity_gifts": null,
  //     "pray_score": 11700,
  //     "pray_reward_status": 1,
  //     "pray_reward_list": [
  //         {
  //             "icon": "http://img01.mehiya.com/imgv2/png/id/138869329534",
  //             "name": "‪Room Frame*1 days",
  //             "value": 300
  //         },
  //         {
  //             "icon": "https://img01.mehiya.com/imgv2/png/id/192690617568",
  //             "name": "‪Frame*1day(s)",
  //             "value": 500
  //         },
  //         {
  //             "icon": "https://img01.mehiya.com/imgv2/png/id/173698800235",
  //             "name": "‪coins*50",
  //             "value": 50
  //         }
  //     ],
  //     "day_or_night": 2,
  //     "day_hour_range": [
  //         0,
  //         10
  //     ],
  //     "night_hour_range": [
  //         10,
  //         24
  //     ],
  //     "pray_reward_stages": [
  //         {
  //             "score_range": [
  //                 1000,
  //                 5000
  //             ],
  //             "reward_list": [
  //                 {
  //                     "icon": "http://img01.mehiya.com/imgv2/png/id/97328895415",
  //                     "name": "‪Bubble *1 day(s)",
  //                     "value": 300
  //                 },
  //                 {
  //                     "icon": "http://img01.mehiya.com/imgv2/png/id/138869329534",
  //                     "name": "‪Room Frame*1 days",
  //                     "value": 300
  //                 }
  //             ]
  //         },
  //         {
  //             "score_range": [
  //                 5000,
  //                 20000
  //             ],
  //             "reward_list": [
  //                 {
  //                     "icon": "http://img01.mehiya.com/imgv2/png/id/138869329534",
  //                     "name": "‪Room Frame*1 days",
  //                     "value": 300
  //                 },
  //                 {
  //                     "icon": "https://img01.mehiya.com/imgv2/png/id/192690617568",
  //                     "name": "‪Frame*1day(s)",
  //                     "value": 500
  //                 },
  //                 {
  //                     "icon": "https://img01.mehiya.com/imgv2/png/id/173698800235",
  //                     "name": "‪coins*50",
  //                     "value": 50
  //                 }
  //             ]
  //         },
  //         {
  //             "score_range": [
  //                 20000,
  //                 0
  //             ],
  //             "reward_list": [
  //                 {
  //                     "icon": "http://img01.mehiya.com/imgv2/png/id/138869329534",
  //                     "name": "‪Room Frame*1 days",
  //                     "value": 300
  //                 },
  //                 {
  //                     "icon": "https://img01.mehiya.com/imgv2/png/id/192690617568",
  //                     "name": "‪Frame*1day(s)",
  //                     "value": 500
  //                 },
  //                 {
  //                     "icon": "https://img01.mehiya.com/imgv2/png/id/173698800235",
  //                     "name": "‪coins*300",
  //                     "value": 300
  //                 }
  //             ]
  //         }
  //     ]
  // }
  }
)
// 2024斋月greedyRecharge页面信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132030025
export const greedyRechargePage = createAsyncThunk(
  '/live/activity/greedy_recharge_page',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/activity/greedy_recharge_page', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return {
      ...resp.data.data,
    }
  }
)
export interface ActType {
  type: ACTIVITIESSTRING
  icon: string
  status: ACTSTATUS
  time_range: Array<string>
}
export interface CheckType {
  day_idx: number
  current_date: string
  status: number
  is_today: boolean
  reward_id: number
  reward_name: string
  reward_icon: string
  reward_desc: string
}

export interface RewardType {
  name: string
  icon: string
}
export interface RedEnvelopeType {
  level: number
  quota: number
  threshold: number
  unlocked: boolean
  rewards: Array<RewardType>
}
interface InitialStateType {
  activities?: Array<ActType>
  check_in_page_info?: Array<Array<CheckType>>
  page?: number
  today_page?: number
  red_page?: {
    activity_countdown?: number // 活动倒计时
    current_level?: number // 红包等级
    red_envelope_levels?: Array<RedEnvelopeType>
    first_entry?: boolean // 是否首次进入页面
    coin_condition?: number
  } // 红包大派送
  map?: any
  is_open?: boolean
  open_red_envelope?: {
    rewards?: Array<RewardType>
    status?: 0 | 1 | 2 // 0 已领取 1 成功 2 红包已过期
    level?: number
    is_self?: boolean // 是不是自己
  }
  recharge_list?: {
    name?: string
    status?: 0 | 1 | 2
  }[]
  receive_gift_list?: {
    name?: string
    status?: 0 | 1 | 2
  }[]
  prayPage?: any
  greedy_recharge_page?: {
    bet_targets?: Array<any> // 下注目标置
    bet_tokens?: Array<number> // 下注金额配置
    recharge_coins?: number // 已充值金币数
    game_tokens?: number // 当前游戏币数
    is_first_visit?: boolean // 是否首次访问
    notices?: Array<any> // 中奖播报
  }
}

const initialState: InitialStateType = {
  red_page: {
    first_entry: false, // 是否首次进入，初始为false
  },
  map: {},
  is_open: false, // 红包是否打开， 初始false,打开一次红包后置true
  open_red_envelope: {},
  prayPage: {},
  recharge_list: [],
  receive_gift_list: [],
  greedy_recharge_page: {},
}

export const Ramadan2024Slice = createSlice({
  name: 'Ramadan2024',
  initialState,
  reducers: {
    setRedBagClose: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        ...state,
        is_open: action.payload,
      })
    },
    setFirstEntry: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        red_page: {
          ...state?.red_page,
          first_entry: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRamadanCenter.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(getActiveClock.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(getRedPage.fulfilled, (state, action) => {
      Object.assign(state.red_page, action.payload)
    })
    builder.addCase(get_reward_by_tag.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(openRedEnvelope.fulfilled, (state, action) => {
      Object.assign(state.open_red_envelope, action.payload)
    })
    builder.addCase(rdn_pray_page.fulfilled, (state, action) => {
      Object.assign(state.prayPage, action.payload)
    })
    builder.addCase(greedyRechargePage.fulfilled, (state, action) => {
      Object.assign(state.greedy_recharge_page, action.payload)
    })
  },
})
export default Ramadan2024Slice.reducer
export const Ramadan2024Actions = Ramadan2024Slice.actions
